import { router } from "..";
import { setAddSongs, setLobbyStage, setResultsStage, setVoteStage } from "../slices/main/mainSlice";
import { store } from "../slices/store";
import { BASE_WS_URL } from "../utils/constants";
import { EStages } from "../utils/types";

let socket: WebSocket | null = null;

const parseJSON = (json: string) => {
  try {
    const data = JSON.parse(json);
    return data;
  } catch (error) {
    return false;
  }
};

const onMessage = (e: MessageEvent<any>) => {
  console.log(e.data);
  const data = parseJSON(e.data);
  // switch case
  if (data.stage === EStages.lobby) {
    store.dispatch(setLobbyStage(data));
  } else if (data.stage === EStages.add_songs) {
    store.dispatch(setAddSongs(data))
  } else if (data.stage === EStages.vote) {
    store.dispatch(setVoteStage(data));
  } else if (data.stage === EStages.results) {
    store.dispatch(setResultsStage(data));
  }
}

const onAdminMessage = (e: MessageEvent<any>) => {
  onMessage(e);
}

const onUserMessage = (e: MessageEvent<any>) => {
  onMessage(e);
}

export const setupWebSocket = (roomId: string, userId: string, isAdmin: boolean) => {
  if (socket) {
    socket.close();
  }
  const socketURL = `${BASE_WS_URL}rooms/${roomId}/ws/${userId}`;
  socket = new WebSocket(socketURL);

  socket.onopen = () => console.log('socket connection: ', socketURL, 'as ', isAdmin ? 'admin' : 'user', ' is established');
  socket.onmessage = isAdmin ? onAdminMessage : onUserMessage;
  socket.onclose = () => router.navigate('/close-ws');
};

export const getWebSocket = () => {
  return socket;
};
